module.exports = __webpack_public_path__ + "img/download.4c7a5b0f.svg";